
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chip } from "primereact/chip";
import { useRef, useState } from "react";
import { DataScroller } from 'primereact/datascroller';
import { Button } from "primereact/button";



export default function AcoesCompleta({
  acoes
}: {
  acoes: any
}) {
  const { t } = useTranslation();
  const ds = useRef<DataScroller>(null);
  const [loader, setLoader] = useState<number>(10);
  const footer = <Button disabled={acoes.length <= 10 || loader >= acoes.length} className="buttom-custom" icon="pi pi-plus" label="Mais Ações" onClick={() => { setLoader(loader + 10); ds.current!.load(); }} />;

  const formatDateToBR = (dateString: string) => {
    if (!dateString) return 'Não Informado';

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR');
    } catch (error) {
      return dateString;
    }
  };

  const itemTemplate = (acao: any) => {
    return (
      <>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('processo')}</label>
              <Chip style={{ width: "100%" }} label={acao.numero} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('comarca')}</label>
              <Chip style={{ width: "100%" }} label={acao.comarca} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('vara')}</label>
              <Chip style={{ width: "100%" }} label={acao.vara} />
            </div>
          </div>
          <div className="col">
            <div >
              <label className="label-dados">{t('cidadeUF')}</label>
              <Chip style={{ width: "100%" }} label={acao.cidadeUF} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('tipo')}</label>
              <Chip style={{ width: "100%" }} label={acao.tipo} />
            </div>
          </div>
          <div className="col">
            <div >
              <label className="label-dados">{t('Classe Processual')}</label>
              <Chip style={{ width: "100%" }} label={acao.classeProcessual ? acao.classeProcessual : 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('valor')}</label>
              <Chip style={{ width: "100%" }} label={acao.valor ? acao.valor : 'Não Informado'} />
            </div>
          </div>
          <div className="col">
            <div >
              <label className="label-dados">{t('origem')}</label>
              <Chip style={{ width: "100%" }} label={acao.origem} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('Código CNJ')}</label>
              <Chip style={{ width: "100%" }} label={acao.classeProcessualCodigoCNJ ? acao.classeProcessualCodigoCNJ : 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('assunto')}</label>
              <Chip style={{ width: "100%" }} label={acao.assunto ? acao.assunto : 'Não Informado'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('status')}</label>
              <Chip style={{ width: "100%" }} label={acao.status ? acao.status : 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('justicaGratuita')}</label>
              <Chip style={{ width: "100%" }} label={acao.eJuizaGratuita && acao.eJuizaGratuita ? 'Sim' : 'Não'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('prioritario')}</label>
              <Chip style={{ width: "100%" }} label={acao.ePrioritario && acao.ePrioritario ? 'Sim' : 'Não'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('processoDigital')}</label>
              <Chip style={{ width: "100%" }} label={acao.eProcessoDigital && acao.eProcessoDigital ? 'Sim' : 'Não'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('segredoJustica')}</label>
              <Chip style={{ width: "100%" }} label={acao.eSegredoJustica && acao.eSegredoJustica ? 'Sim' : 'Não'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('tutelaAntecipada')}</label>
              <Chip style={{ width: "100%" }} label={acao.eTutelaAntecipada && acao.eTutelaAntecipada ? 'Sim' : 'Não'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('juiz')}</label>
              <Chip style={{ width: "100%" }} label={acao.juiz ?? 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('dataDistribuicao')}</label>
              <Chip style={{ width: "100%" }} label={acao.dataDistribuicao} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('dataAutuacao')}</label>
              <Chip style={{ width: "100%" }} label={acao.dataAutuacao ? formatDateToBR(acao.dataAutuacao) : 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('grauProcesso')}</label>
              <Chip style={{ width: "100%" }} label={acao.grauProcesso ?? 'Não Informado'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('dataArquivamento')}</label>
              <Chip style={{ width: "100%" }} label={acao.dataArquivamento ? formatDateToBR(acao.dataArquivamento) : 'Não Informado'} />
            </div>
          </div>

        </div>
        <br></br>
        <DataTable header={t('partes')} size="small" value={acao.partes} tableStyle={{ minWidth: '50rem' }}>
          <Column field="tipo" header={t('tipo')}></Column>
          <Column field="data" header={t('data')}></Column>
          <Column field="polo" header={t('polo')}></Column>
          <Column field="advogado" header={t('advogados')}></Column>
          <Column field="documento" header={t('documento')}></Column>
          <Column field="nome" header={t('nome')}></Column>
        </DataTable>
        {acao.julgamentos && acao.julgamentos.length > 0 && (
          <>
            <br></br>
            <DataTable header={t('julgamentos')} size="small" value={acao.julgamentos} tableStyle={{ minWidth: '50rem' }}>
              <Column field="dataJulgamento" header={t('data')}></Column>
              <Column field="tipoJulgamento" header={t('tipo')}></Column>
              <Column field="statusJulgamento" header={t('status')}></Column>
              <Column field="advogado" header={t('advogados')}></Column>
              <Column field="documento" header={t('documento')}></Column>
              <Column field="nome" header={t('nome')}></Column>
            </DataTable>
          </>
        )}
        {acao.penhoras && acao.penhoras.length > 0 && (
          <>
            <br></br>
            <Panel header={t('penhoras')} collapsed toggleable>
              {acao.penhoras.map((penhora: any, index: number) => (
                <div key={index}>
                  <h4>{t('penhora')} {index + 1}</h4>
                  <div className="grid">
                    <div className="col p-fluid flex flex-wrap">
                      <div >
                        <label className="label-dados">{t('tipo')}</label>
                        <Chip style={{ width: "100%" }} label={penhora.tipo} />
                      </div>
                    </div>
                    <div className="col p-fluid flex flex-wrap">
                      <div >
                        <label className="label-dados">{t('data')}</label>
                        <Chip style={{ width: "100%" }} label={penhora.data} />
                      </div>
                    </div>
                  </div>
                  <div className="grid">
                    <div className="col p-fluid flex flex-wrap">
                      <div >
                        <label className="label-dados">{t('trecho')}</label>
                        <Chip style={{ width: "100%" }} label={penhora.trecho} />
                      </div>
                    </div>
                  </div>
                  <br></br>
                </div>
              ))}
            </Panel>
          </>
        )}

        <br></br>
        <br></br>
        {acao.movimentos ? (
          <>
            <br></br>
            <Panel header={t('movimentacoes')} collapsed toggleable>
              <DataTable header={t('movimentacoes')} size="small" value={acao.movimentos} tableStyle={{ minWidth: '50rem' }}>
                <Column field="data" header={t('data')}></Column>
                <Column field="descricao" header={t('descricao')}></Column>
              </DataTable>
            </Panel>
          </>
        ) : ''}
        <br></br>
        <div className="line"></div>
        <br></br>
      </>
    )
  }

  const COLORS = {
    global: { from: '#4f46e5', to: '#6366f1' },
    autor:  { from: '#0369a1', to: '#0891b2' },
    reu:    { from: '#b91c1c', to: '#dc2626' },
  };

  const resumoCard = (item: any, index: number, palette: { from: string; to: string }) => (
    <div key={index} style={{
      background: `linear-gradient(135deg, ${palette.from}, ${palette.to})`,
      borderRadius: '14px',
      padding: '1.1rem 1.2rem',
      minWidth: '150px',
      flex: '1',
      boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', right: '-14px', bottom: '-14px',
        width: '70px', height: '70px', borderRadius: '50%',
        background: 'rgba(255,255,255,0.08)',
      }} />
      <div style={{
        position: 'absolute', right: '22px', bottom: '22px',
        width: '36px', height: '36px', borderRadius: '50%',
        background: 'rgba(255,255,255,0.06)',
      }} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: item.details?.length ? '0.7rem' : 0 }}>
        <div>
          <div style={{ color: 'rgba(255,255,255,0.72)', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.25rem' }}>
            {item.label}
          </div>
          <div style={{ color: 'white', fontSize: '1.9rem', fontWeight: 700, lineHeight: 1 }}>
            {item.value}
          </div>
        </div>
        <div style={{
          background: 'rgba(255,255,255,0.18)',
          borderRadius: '10px',
          width: '38px', height: '38px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <i className={item.icon} style={{ color: 'white', fontSize: '1.1rem' }} />
        </div>
      </div>

      {item.details && item.details.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginTop: '0.4rem' }}>
          {item.details.map((d: string, i: number) => (
            <span key={i} style={{
              background: 'rgba(255,255,255,0.22)',
              color: 'white',
              borderRadius: '999px',
              padding: '0.15rem 0.55rem',
              fontSize: '0.65rem',
              whiteSpace: 'nowrap',
              letterSpacing: '0.02em',
            }}>{d}</span>
          ))}
        </div>
      )}
    </div>
  );

  const SectionHeader = ({ icon, label, color }: { icon: string; label: string; color: string }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
      <div style={{ width: '4px', height: '20px', borderRadius: '2px', background: color }} />
      <i className={icon} style={{ color, fontSize: '1rem' }} />
      <span style={{ color, fontWeight: 700, fontSize: '0.95rem', letterSpacing: '0.03em' }}>{label}</span>
    </div>
  );

  const globalResumos = acoes[0]?.resumos?.filter((r: any) => !r.group) ?? [];
  const autorResumos  = acoes[0]?.resumos?.filter((r: any) => r.group === 'Autor') ?? [];
  const reuResumos    = acoes[0]?.resumos?.filter((r: any) => r.group === 'Réu') ?? [];

  return (
    <Panel header={t('acoesCompleta')}>
      {globalResumos.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', marginBottom: '1.25rem' }}>
          {globalResumos.map((item: any, i: number) => resumoCard(item, i, COLORS.global))}
        </div>
      )}

      {autorResumos.length > 0 && (
        <div style={{ marginBottom: '1.25rem' }}>
          <SectionHeader icon="pi pi-user" label="Como Autor" color={COLORS.autor.from} />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
            {autorResumos.map((item: any, i: number) => resumoCard(item, i, COLORS.autor))}
          </div>
        </div>
      )}

      {reuResumos.length > 0 && (
        <div style={{ marginBottom: '1.25rem' }}>
          <SectionHeader icon="pi pi-user-minus" label="Como Réu" color={COLORS.reu.from} />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
            {reuResumos.map((item: any, i: number) => resumoCard(item, i, COLORS.reu))}
          </div>
        </div>
      )}

      <br />
      <DataScroller ref={ds} value={acoes} itemTemplate={itemTemplate} rows={10} loader footer={footer} />
    </Panel>
  )
}
